const SET_SELECTED_TAB = "SET_SELECTED_TAB";
const UpcEditorSymbols = {
  SET_SELECTED_TAB,
};
export default UpcEditorSymbols;
